export function clearSessionForRescan(store) {
    if (!store) return;

    store.dispatch("setToken", "");
    store.dispatch("setUserInfoCollection", []);
    store.dispatch("setIsBorrow", undefined);
    store.dispatch("setOrderInfo", {});
    store.dispatch("setRepaymentInfo", {});
    store.commit("appConfig/SET_DEVICE_CODE", undefined);
    store.commit("appConfig/SET_INTERNAL_ID", undefined);
    store.commit("appConfig/SET_MACHINE_PRECHECK_ERROR", undefined);

    sessionStorage.removeItem("lastDeviceCode");
    sessionStorage.removeItem("hasFetchedAppConfig");
}
